export const localeToCurrencyMap = {
    'en-IE': 'EUR', // Ireland
    'de-DE': 'EUR', // Germany
    'en-GB': 'GBP', // UK
    'en-US': 'USD', // US
    'fr-FR': 'EUR', // France
    'es-ES': 'EUR', // Spain
    'it-IT': 'EUR', // Italy
    'ja-JP': 'JPY', // Japan
    'zh-CN': 'CNY', // China
    'ru-RU': 'RUB', // Russia
    'ko-KR': 'KRW', // South Korea
    'pt-BR': 'BRL', // Brazil
    'in-IN': 'INR', // India
    'au-AU': 'AUD', // Australia
    'ca-CA': 'CAD', // Canada
    'mx-MX': 'MXN', // Mexico
    'nl-NL': 'EUR', // Netherlands
    'se-SE': 'SEK', // Sweden
    'ch-CH': 'CHF', // Switzerland
    'no-NO': 'NOK', // Norway
    'dk-DK': 'DKK', // Denmark
    'pl-PL': 'PLN', // Poland
    'tr-TR': 'TRY', // Turkey
    'za-ZA': 'ZAR', // South Africa
    'ar-SA': 'SAR', // Saudi Arabia
    'th-TH': 'THB', // Thailand
    'sg-SG': 'SGD', // Singapore
    'my-MY': 'MYR', // Malaysia
    'id-ID': 'IDR', // Indonesia
    'ph-PH': 'PHP', // Philippines
    'hk-HK': 'HKD', // Hong Kong
    'nz-NZ': 'NZD', // New Zealand
};

export function getCurrencyCodeFromLocaleLanguage(localeLanguage) {
    if (!localeLanguage) {
        throw new Error('Invalid locale.');
    }
    const currencyCode = localeToCurrencyMap[localeLanguage];
    return currencyCode;
}

const localeToDecimalSeparatorMap = {
    'en-US': '.', // United States
    'en-CA': '.', // Canada (English-speaking regions)
    'ja-JP': '.', // Japan
    'zh-TW': '.', // Taiwan
    'en-GB': '.', // United Kingdom
    'en-IE': '.', // Ireland
    'he-IL': '.', // Israel
    'en-AU': '.', // Australia
    'en-NZ': '.', // New Zealand
    'zh-HK': '.', // Hong Kong
    'en-IN': '.', // India (except for lakhs and crores grouping)
    'sq-AL': ',', // Albania
    'fr-BE': ',', // Belgium (French-speaking regions)
    'pt-BR': ',', // Brazil
    'bg-BG': ',', // Bulgaria
    'es-CR': ',', // Costa Rica
    'hr-HR': ',', // Croatia
    'cs-CZ': ',', // Czech Republic
    'da-DK': ',', // Denmark
    'et-EE': ',', // Estonia
    'fi-FI': ',', // Finland
    'fr-FR': ',', // France
    'de-DE': ',', // Germany
    'el-GR': ',', // Greece
    'hu-HU': ',', // Hungary
    'it-IT': ',', // Italy (in education)
    'lv-LV': ',', // Latvia
    'lt-LT': ',', // Lithuania
    'pt-MO': ',', // Macau (in Portuguese text)
    'es-MX': ',', // Mexico
    'ar-MA': ',', // Morocco
    'no-NO': ',', // Norway
    'es-PE': ',', // Peru
    'pl-PL': ',', // Poland
    'pt-PT': ',', // Portugal
    'ru-RU': ',', // Russia
    'sr-RS': ',', // Serbia (informal)
    'sk-SK': ',', // Slovakia
    'sl-SI': ',', // Slovenia
    'af-ZA': ',', // South Africa (official)
    'es-ES': ',', // Spain (official use since 2010)
    'sv-SE': ',', // Sweden
    'de-CH': ',', // Switzerland (federal texts, except currency numbers)
    'uk-UA': ',', // Ukraine
    'vi-VN': ',', // Vietnam (in education)
};

export const getDecimalSeparatorForLocaleCode = (localeLanguage) => {
    if (!localeLanguage) {
        throw new Error('Invalid locale.');
    }

    const decimalSeparator = localeToDecimalSeparatorMap?.[localeLanguage];

    if (!decimalSeparator) {
        throw new Error(`${localeLanguage} is not found.`);
    }

    return decimalSeparator;
};

const currencySymbols = [
    '$',
    '€',
    '£',
    '¥',
    '₹',
    '₽',
    '₩',
    '₪',
    '₫',
    '₴',
    '₱',
    '₭',
    '₦',
    '₲',
    '₵',
    '₡',
    '₢',
    '₣',
    '₤',
    '₧',
    '₨',
    '₩',
    '₸',
    '₺',
    '₼',
    '₽',
    '₾',
];

export const currencyStringHasMoreThanTwoDecimals = (
    currencyFormattedString: string,
    localeLanguage: string
): boolean => {
    const decimalSeparator = getDecimalSeparatorForLocaleCode(localeLanguage);

    // Remove currency symbols
    let cleanedString = currencyFormattedString;
    currencySymbols.forEach((symbol) => {
        cleanedString = cleanedString.replace(new RegExp(`\\${symbol}`, 'g'), '');
        // Remove whitespace
        // eslint-disable-next-line no-irregular-whitespace
        cleanedString = cleanedString.replace(new RegExp(`\\ `, 'g'), '');
    });

    // Split the string by the decimal separator
    const parts = cleanedString.split(decimalSeparator);

    // Check if there are more than 3 decimal places
    if (parts.length > 1 && parts[1].length === 3) {
        return true;
    }

    return false;
};
